import { configureStore } from '@reduxjs/toolkit';

import crtUserSlice from './crt-user-slice';
import messageSlice from './message-slice';
import postsSlice, { fetchPostsFirstBatch, fetchPostsNextBatch, createComment, deleteComment, editComment, editPost, deletePost, createReaction, deleteReaction } from './posts-slice';
import usersSlice, { fetchAllUsers } from './users-slice';

export const { setCrtUser, resetCrtUser, setShouldAskToSignIn, resetShouldAskToSignIn } = crtUserSlice.actions
export const { setMessage, restMessage } = messageSlice.actions
export { fetchAllUsers, fetchPostsFirstBatch, fetchPostsNextBatch, createComment, deleteComment, editComment, editPost, deletePost, createReaction, deleteReaction };

export const store = configureStore({
  reducer: {
    crtUser: crtUserSlice.reducer,
    users: usersSlice.reducer,
    message: messageSlice.reducer,
    posts: postsSlice.reducer,
  }
})
